import { TSmsLog } from 'src/types/sms-log'
import { TPatient } from 'src/types/patient'
import { InboundSmsLogCard } from './inbound-sms-log-card.component'
import { OutboundSmsLogCard } from './outbound-sms-log-card.component'

const SmsLogCard = ({
  smsLog,
  patient,
}: {
  smsLog: TSmsLog
  patient: Pick<TPatient, 'id' | 'firstname' | 'lastname'>
}) => {
  const isSmsSentByPatient = smsLog.inbound === true
  if (isSmsSentByPatient) {
    return <InboundSmsLogCard smsLog={smsLog} patient={patient} />
  }

  return <OutboundSmsLogCard smsLog={smsLog} />
}

export { SmsLogCard }
